export const PERMISSIONS = {
  main: [
    {
      id: 159,
      action: 'plugin::content-manager.explorer.create',
      actionParameters: {},
      subject: 'plugin::tree-menus.menu',
      properties: {
        fields: ['title', 'slug', 'items'],
        locales: ['en', 'vi'],
      },
      conditions: [],
    },
    {
      id: 160,
      action: 'plugin::content-manager.explorer.read',
      actionParameters: {},
      subject: 'plugin::tree-menus.menu',
      properties: {
        fields: ['title', 'slug', 'items'],
        locales: ['en', 'vi'],
      },
      conditions: [],
    },
    {
      id: 161,
      action: 'plugin::content-manager.explorer.update',
      actionParameters: {},
      subject: 'plugin::tree-menus.menu',
      properties: {
        fields: ['title', 'slug', 'items'],
        locales: ['en', 'vi'],
      },
      conditions: [],
    },
    {
      id: 162,
      action: 'plugin::content-manager.explorer.delete',
      actionParameters: {},
      subject: 'plugin::tree-menus.menu',
      properties: {
        locales: ['en', 'vi'],
      },
      conditions: [],
    },
    {
      id: 163,
      action: 'plugin::content-manager.explorer.publish',
      actionParameters: {},
      subject: 'plugin::tree-menus.menu',
      properties: {
        locales: ['en', 'vi'],
      },
      conditions: [],
    },
  ],
}
